import React from 'react';
import PropTypes from 'prop-types';
import { PathLine } from 'react-svg-pathline';
import cn from 'classnames';

class FlowGraphEdge extends React.Component {
	constructor(props) {
		super(props);
		this.handleSelect = this.handleSelect.bind(this);
	}

	_ensureSelectableProperties(props) {
		[ 'hovered', 'selected' ].forEach(prop => {
			if (props[prop] && props.selectable !== true) {
				throw new Error(`'${prop}' requires 'selectable'`);
			}
		});
	}

	componentWillMount() {
		this._ensureSelectableProperties(this.props);
	}

	componentWillReceiveProps(props) {
		this._ensureSelectableProperties(props);
	}

	handleSelect(ev) {
		ev && ev.stopPropagation();
		ev && ev.preventDefault();
		if (this.props.selectable) {
			this.props.onSelect();
		}
	}

	render() {
		const {
			className,
			points,
			selectable,
			selected,
			hovered: hover,
			invalid
		} = this.props;
		let start;
		let end;

		if (selected) {
			start = points[0];
			end = points[points.length - 1];
		}

		return (
			<g
				className={cn('graph-edge', className, { hover, selected })}
				onClick={this.handleSelect}
				id={this.props.id}
			>
				<PathLine
					className={cn('edge', { hover, invalid })}
					key="edge"
					points={points}
					r={10}
				/>
				{selectable && (
					<PathLine
						className="hover-target"
						key="hover"
						points={points}
						onMouseEnter={this.props.onMouseEnter}
						onMouseLeave={this.props.onMouseLeave}
						r={10}
					/>
				)}
				{selected && (
					<g>
						<circle cx={start.x} cy={start.y} r={4} />
						<circle cx={end.x} cy={end.y} r={4} />
					</g>
				)}
			</g>
		);
	}
}

FlowGraphEdge.propTypes = {
	/**
	 * Unique identifier.
	 */
	id: PropTypes.string.isRequired,

	/**
	 * Flag to indicate the edge is selected.
	 */
	selected: PropTypes.bool,

	/**
	 * Flag to indicate the edge is selectable.
	 */
	selectable: PropTypes.bool,

	/**
	 * Flag to indicate the edge is hovered.
	 */
	hovered: PropTypes.bool,

	/**
	 * Flag to indicate the edge is invalid.
	 */
	invalid: PropTypes.bool,

	/**
	 * An array of edge points.
	 */
	points: PropTypes.arrayOf(PropTypes.shape({
		x: PropTypes.number.isRequired,
		y: PropTypes.number.isRequired
	})).isRequired,

	/**
	 * Callback when a edge is selected.
	 */
	onSelect: PropTypes.func,

	/**
	 * Callback function when mouse hovers over edge.
	 */
	onMouseEnter: PropTypes.func,

	/**
	 * Callback function when mouse hovers outside of edge.
	 */
	onMouseLeave: PropTypes.func
};

FlowGraphEdge.defaultProps = {
	selectable: false,
	selected: false,
	hovered: false,
	invalid: false
};

export default FlowGraphEdge;
